<template>
  <v-container class="oauth-callback fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular
          :size="64"
          :width="6"
          color="primary"
          indeterminate
        />
        <p class="oauth-callback__text mt-4">Вход через ЭВО ID…</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserService from '@/services/user-service';
import {
  consumeOAuthCallback,
  consumeOAuthNextPath,
  hasOAuthCallbackParams,
} from '@/services/oauth';
import { store } from '@/main';
import ACL from '@/services/ACL';
import { mapActions } from 'vuex';

export default {
  name: 'OAuthCallback',
  mounted () {
    this.finishLogin();
  },
  methods: {
    ...mapActions({
      loadAllAgents: 'Agents/loadAllAgents',
      getAllSettingsTables: 'User/getAllSettingsTables',
    }),
    async finishLogin () {
      if (!hasOAuthCallbackParams()) {
        await this.$router.replace({ name: 'Home' }).catch(() => {});
        return;
      }

      const callback = consumeOAuthCallback();

      if (callback.error) {
        const denied = callback.error === 'access_denied';
        this.$flash_warning(denied
          ? 'Вход через ЭВО ID отклонён.'
          : (callback.errorDescription || 'Ошибка авторизации ЭВО ID.'));
        await this.$router.replace('/').catch(() => {});
        return;
      }

      if (!callback.code || !callback.verifier || callback.state !== callback.expectedState) {
        this.$flash_warning('Сессия входа через ЭВО ID устарела. Попробуйте ещё раз.');
        await this.$router.replace('/').catch(() => {});
        return;
      }

      try {
        await UserService.instance.authEvoId({
          code: callback.code,
          code_verifier: callback.verifier,
          redirect_uri: callback.redirectUri,
        });
        this.loadAllAgents();
        this.getAllSettingsTables();
        await this.redirectAfterLoginIfAllowed();
      } catch (err) {
        const message = err.response?.data?.message || 'Ошибка авторизации ЭВО ID.';
        this.$flash_warning(message);
        await this.$router.replace('/').catch(() => {});
      }
    },
    async redirectAfterLoginIfAllowed () {
      const roleName = store.getters.roleName;
      const permissions = ACL.roles[roleName]?.routes || [];
      const next = consumeOAuthNextPath();
      const currentPath = next || store.state.redirectAfterLogin;
      const matchedRoute = currentPath ? this.$router.match(currentPath) : null;
      const isSafeTarget = matchedRoute &&
        matchedRoute.name &&
        matchedRoute.name !== 'OAuthCallback' &&
        matchedRoute.name !== 'NotFound' &&
        permissions.includes(matchedRoute.name);

      if (isSafeTarget && this.$route.fullPath !== currentPath) {
        await this.$router.replace(currentPath).catch(() => {});
      } else {
        await this.$router.replace({ name: 'Home' }).catch(() => {});
      }
      await store.dispatch('clearRedirect');
    },
  },
};
</script>

<style lang="scss" scoped>
.oauth-callback {
  background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 50%, #fff8e1 100%);
  min-height: 100vh;
}

.oauth-callback__text {
  color: #546e7a;
  font-size: 1rem;
}
</style>
